import {
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
} from '@mui/material';

export interface TimelinePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export const getTimelinePaginationSummary = (
  page: number,
  pageSize: number,
  total: number,
) =>
  total === 0
    ? 'Nenhum resultado encontrado.'
    : `Exibindo ${(page - 1) * pageSize + 1}–${Math.min(
        page * pageSize,
        total,
      )} de ${total} registros`;

export default function TimelinePagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}: TimelinePaginationProps) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const summary = getTimelinePaginationSummary(page, pageSize, total);
  if (total === 0) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        role="status"
        sx={{ pt: 1 }}>
        {summary}
      </Typography>
    );
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', sm: 'center' }}
      sx={{ pt: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {summary}
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between">
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="timeline-page-size-label">Por página</InputLabel>
          <Select
            labelId="timeline-page-size-label"
            value={pageSize}
            label="Por página"
            onChange={(event) => onPageSizeChange(Number(event.target.value))}>
            {[10, 20, 50, 100].map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Pagination
          count={pageCount}
          page={page}
          onChange={(_, nextPage) => onPageChange(nextPage)}
          color="primary"
          shape="rounded"
          siblingCount={0}
        />
      </Stack>
    </Stack>
  );
}
